"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.context = exports.ParseUtils = exports.spoon = exports.utils = exports.config = exports.BryxApi = exports.models = void 0;
/**
 * @module root
 * @preferred
 * _Examples:_
 * ``` typescript
 * import { bryxApi } from "bryx-utils";
 * ```
 * ``` typescript
 * import {
 *   models: { Auth },
 *   bryxApi: { ApiResult, BryxApi },
 *   utils: { BryxLocal }
 * } from "bryx-utils";
 * ```
 */
var models = require("./models");
exports.models = models;
var index_1 = require("./utils/BryxApi/index");
exports.BryxApi = index_1.default;
/* tslint:disable */
// Config type is now in models and is not static
var config = require("./config");
exports.config = config;
/* tslint:enable */
var utils = require("./utils");
exports.utils = utils;
var spoon = require("./spoonClient");
exports.spoon = spoon;
var cerealParse_1 = require("./cerealParse");
Object.defineProperty(exports, "ParseUtils", { enumerable: true, get: function () { return cerealParse_1.ParseUtils; } });
var context = require("./context");
exports.context = context;
// export default { BryxApi } from "./utils/bryxApi";
//# sourceMappingURL=index.js.map